"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redact = exports.REDACT_ERROR = exports.EXPLICIT_REDACTION = void 0;
const utils_1 = require("./utils");
// Define default key names that should be PII redacted
//Possible variants are declared in snake_case and kebab-case
//camelCase and PascalCase variants are covered by applying the toLowerCase method before the search
const PII_REDACTION_KEYS = new Set([
    'address-line-1',
    'address-line-2',
    'address-line1',
    'address-line2',
    'address_line1',
    'address_line2',
    'address_line_1',
    'address_line_2',
    'addressline1',
    'addressline2',
    'authorization',
    'card-number',
    'card_number',
    'cardholder',
    'cardholder-name',
    'cardholder_name',
    'cardholdername',
    'cardnumber',
    'city',
    'country',
    'email',
    'expiry-month',
    'expiry-year',
    'expiry_month',
    'expiry_year',
    'expirymonth',
    'expiryyear',
    'first-name',
    'first_name',
    'firstname',
    'guest-name',
    'guest_name',
    'guestname',
    'holder-name',
    'holder_name',
    'holdername',
    'last-name',
    'last_name',
    'lastname',
    'locality',
    'mobile',
    'name',
    'name-on-card',
    'name_on_card',
    'nameoncard',
    'phone',
    'phone-number',
    'phone_number',
    'phonenumber',
    'postal-code',
    'postal_code',
    'postalcode',
    'state',
    'street-number',
    'street_number',
    'streetnumber',
    'surname',
    'town-city',
    'town_city',
    'towncity',
    'user-lat',
    'user-lng',
    'user_lat',
    'user_lng',
    'userlat',
    'userlng',
    'zip',
    'zip-code',
    'zip_code',
    'zipcode',
]);
exports.EXPLICIT_REDACTION = '__REDACTED__';
exports.REDACT_ERROR = '__FAILED_TO_REDACT__';
const MAX_BIN_LENGTH = 4;
/**
 * Recursively iterates over object tree, array items, and string value, and performs PII redaction.
 * @param value
 * @param keysToRedact
 *
 * @deprecated Please, do not use this function. Document and understand your API responses and
 * redact where necessary only the properties you need. This function might cause memory leaks
 * given it recursively execute a regex operation on all properties from an object.
 */
const redact = (value, keysToRedact = PII_REDACTION_KEYS) => {
    const isKeyToRedact = (key) => {
        if (Array.isArray(keysToRedact)) {
            const lowerCaseKeysToRedact = keysToRedact.map((key) => key.toLowerCase());
            return lowerCaseKeysToRedact.includes(key.toLowerCase());
        }
        else {
            return keysToRedact.has(key.toLowerCase());
        }
    };
    const redactPlainString = (value) => (0, utils_1.hasPiiValues)(value) ? exports.EXPLICIT_REDACTION : value;
    const parseAndRedactString = (stringValue) => {
        try {
            if (!(0, utils_1.isJsonLikeString)(stringValue)) {
                return redactPlainString(stringValue);
            }
            const parsedJson = JSON.parse(stringValue);
            if ((0, utils_1.isPlainObject)(parsedJson) || (0, utils_1.isArray)(parsedJson)) {
                const redacted = redactRecursive(parsedJson);
                return JSON.stringify(redacted);
            }
            else {
                // nested string
                const redacted = parseAndRedactString(parsedJson);
                return JSON.stringify(redacted);
            }
        }
        catch (error) {
            // string is not a valid JSON
            return redactPlainString(stringValue);
        }
    };
    const redactRecursive = (input) => {
        if ((0, utils_1.isArray)(input)) {
            return input.map((element) => redactRecursive(element));
        }
        if ((0, utils_1.isString)(input)) {
            return parseAndRedactString(input);
        }
        if ((0, utils_1.isPlainObject)(input) || input instanceof Error) {
            const redacted = {};
            for (const key of Object.getOwnPropertyNames(input)) {
                const inputValue = input[key];
                if ((0, utils_1.isApiKey)(key)) {
                    redacted[key] = (0, utils_1.getApiKeyTail)(inputValue);
                }
                else if (isKeyToRedact(key)) {
                    redacted[key] = exports.EXPLICIT_REDACTION;
                }
                else if ((0, utils_1.isPlainObject)(inputValue) ||
                    inputValue instanceof Error ||
                    (0, utils_1.isArray)(inputValue)) {
                    redacted[key] = redactRecursive(inputValue);
                }
                else if ((0, utils_1.isBin)(key)) {
                    redacted[key] = String(inputValue).slice(0, MAX_BIN_LENGTH);
                }
                else if ((0, utils_1.isString)(inputValue)) {
                    redacted[key] = parseAndRedactString(inputValue);
                }
                else {
                    redacted[key] = inputValue;
                }
            }
            return Object.create(Object.getPrototypeOf(input), Object.getOwnPropertyDescriptors(redacted));
        }
        return input;
    };
    try {
        return redactRecursive(value);
    }
    catch (e) {
        return exports.REDACT_ERROR;
    }
};
exports.redact = redact;
//# sourceMappingURL=redact.js.map